import { createContext, useCallback, useContext } from 'react';

/** @typedef {import('./offline-queue.js').QueuedReading} QueuedReading */

/** Shared by `MeterQueueProvider` (meter-queue.jsx) and `useMeterQueue`. */
export const MeterQueueContext = createContext(
  /** @type {null | { queue: ReturnType<typeof import('./offline-queue.js').createSubmissionQueue>, entries: QueuedReading[] }} */ (null),
);

/** Queue + current entries; `entryFor(readingId)` = latest queued submission of a reading. */
export function useMeterQueue() {
  const ctx = useContext(MeterQueueContext);
  if (!ctx) throw new Error('useMeterQueue needs <MeterQueueProvider>');
  const { queue, entries } = ctx;
  const entryFor = useCallback((readingId) => entries.filter((e) => String(e.reading_id) === String(readingId)).at(-1) ?? null, [entries]);
  return { queue, entries, entryFor };
}
